export const REPORT_REQUEST_PAYLOAD = Object.freeze({
    TIMEFRAME: 'timeFrame',
    MARKETPLACE: 'marketplace',
    PRODUCTLINES: 'productLines'
})


// WEBPACK FOOTER //
// ./src/constants/payload.js